{
    "en": {
        "translation": {
            "A new regatta message": "A new regatta message",
            "Boat protesting, or requesting redress or reopening": "Boat protesting, or requesting redress or reopening",
            "Boat(s) protested or being considered for redress": "Boat(s) protested or being considered for redress",
            "Bow": "Bow",
            "Bow no": "Bow no",
            "Championship administration permission has been confirmed": "Championship administration permission has been confirmed",
            "Championship administration propose has been submitted": "Championship administration propose has been submitted",
            "Championship administration request has been rejected": "Championship administration request has been rejected",
            "Championship administration request has been submitted": "Championship administration request has been submitted",
            "Date and time": "Date and time",
            "Description of incident": "Description of incident",
            "Edit registration data": "Edit registration data",
            "Email verification required": "Email verification required",
            "Finish": "Finish",
            "Fleet": "Fleet",
            "For more details and hearing time": "For more details and hearing time",
            "General info": "General info",
            "Go to the championship management": "Go to the championship management",
            "Go to the password reset form": "Go to the password reset form",
            "Go to the regatta management": "Go to the regatta management",
            "Go to the regatta page": "Go to the regatta page",
            "Incident": "Incident",
            "Password verification code": "Password verification code",
            "Please verify your email used to create the account, otherwise the account will expire in 30 days": "Please verify your email used to create the account, otherwise the account will expire in 30 days",
            "Protest time limit": "Protest time limit",
            "Race no.": "Race no.",
            "Received by race office": "Received by race office",
            "Regatta administration permission has been confirmed": "Regatta administration permission has been confirmed",
            "Regatta administration propose has been submitted": "Regatta administration propose has been submitted",
            "Regatta administration request has been rejected": "Regatta administration request has been rejected",
            "Regatta administration request has been submitted": "Regatta administration request has been submitted",
            "Regatta entries list": "Regatta entries list",
            "Regatta entry form": "Regatta entry form",
            "Regatta entry has resigned from regatta": "Regatta entry has resigned from regatta",
            "Regatta group entries list": "Regatta group entries list",
            "Regatta group results": "Regatta group results",
            "Regatta protest has been submitted": "Regatta protest has been submitted",
            "Regatta protests list": "Regatta protests list",
            "Regatta results": "Regatta results",
            "Regatta trackers list": "Regatta trackers list",
            "Registration no": "Registration no",
            "Represented by": "Represented by",
            "Sail no": "Sail no",
            "Sail no. and Boat’s name": "Sail no. and Boat’s name",
            "Signature": "Signature",
            "Type of hearing": "Type of hearing",
            "Use this code in password reset form": "Use this code in password reset form",
            "User": "User",
            "Verify email": "Verify email",
            "You are a protestee": "You are a protestee",
            "You are a protestor": "You are a protestor",
            "You can edit your registration data using this link": "You can edit your registration data using this link",
            "You can verify your email using this link": "You can verify your email using this link"
        }
    }
}
